import { makeStyles } from '@material-ui/core';
import { colorSet } from '@components/Provider';

export const useStyles = makeStyles((theme) => ({
  accountTypeStyle: {
    '& .MuiFormGroup-root': {
      flexDirection: 'row',
      width: '100%',
      justifyContent: 'space-between',
      marginBottom: 48,
      [theme.breakpoints.down('md')]: {
        justifyContent: 'center',
        margin: '16px 0px 32px'
      }
    }
  },
  radioBox: {
    display: 'flex',
    border: `1px solid ${colorSet.gray400}`,
    width: 293,
    height: 311,
    borderRadius: 8,
    position: 'relative',
    padding: 20,
    transition: 'all 0.1s ease-in-out',
    '&.disabled': {
      opacity: 0.5,
      '&.disabled': {
        boxShadow: 'none',
        cursor: 'default'
      }
    },
    '&:first-child': {
      [theme.breakpoints.down('md')]: {
        marginBottom: 16
      }
    },
    '& img': {
      position: 'absolute',
      top: 20,
      right: 20,
      [theme.breakpoints.down('md')]: {
        top: '50%',
        right: 14,
        transform: 'translateY(-50%)'
      }
    },
    '& .MuiFormControlLabel-root': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      marginLeft: 0,
      marginRight: 0
    },
    '& .MuiFormControlLabel-labelPlacementBottom': {
      margin: 0,
      flexDirection: 'column'
    },
    '& .MuiRadio-root': {
      alignSelf: 'flex-start',
      marginBottom: 12,
      [theme.breakpoints.down('md')]: {
        marginRight: '8px'
      }
    },
    '& .radioBoxTitle': {
      ...theme.typography.h4,
      color: colorSet.gray900,
      marginBottom: 8
    },
    '& .radioBoxDetail': {
      ...theme.typography.body2,
      color: colorSet.gray700,
      marginBottom: 20,
      whiteSpace: 'pre-line'
    },
    '& .radioBoxDivider': {
      marginBottom: 20,
      width: 48
    },
    '&.selected': {
      boxShadow: 'none',
      border: `2px solid ${colorSet.primary500}`
    },
    '&:hover': {
      cursor: 'pointer'
    },
    [theme.breakpoints.down('md')]: {
      alignItems: 'center',
      width: 'calc(100vw - 32px)',
      height: 92,
      padding: 8,
      '& .radioBoxTitle': {
        ...theme.typography.body1,
        marginBottom: 4
      },
      '& .radioBoxDetail': {
        ...theme.typography.caption,
        marginBottom: 0,
        whiteSpace: 'pre-line'
      },
      '& .MuiRadio-root': {
        marginBottom: 0,
        alignSelf: 'center'
      }
    }
  }
}));
